// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeToList, SubscribeToListApiParameter } from "@hardwoods/App/Services/EmailService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { chain, SendDataToApi } from "@insite/client-framework/Store/CommonHandlers/Subscribe";

export interface SubscribeParameter {
    email: string;
    onSuccess?: () => void;
}

type HandlerType = ApiHandlerDiscreteParameter<SubscribeParameter, SubscribeToListApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { emailAddress: props.parameter.email };
};

export const CustomSendDataToApi: HandlerType = async props => {
    await subscribeToList(props.apiParameter);
};

replaceInChain(chain, SendDataToApi, CustomSendDataToApi);

const subscribeHandler = createHandlerChainRunner(chain, "SubscribeHandler");
export default subscribeHandler;
